import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { Router } from '@angular/router';
import { AccountService, AuthService, CommonService, InternationalizationService, UserService } from '../services';
import { BrandingService } from '../services/branding.service';
import { AccountRegionModel } from '../models/account.model';
import { API_CONFIG, build_Configurations, build_info, environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { LanguageItem } from '../models/language-item.model';
import { ClrDatagrid, ClrDatagridStateInterface } from '@clr/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() pageSidebarTwo;
  @Output() toggleSidebarRightCollapsed = new EventEmitter<boolean>();
  @Output() toggleMobileSidebar = new EventEmitter<boolean>();
  @Output() toggleMobileRightSidebar = new EventEmitter<boolean>();

  regions: Array<AccountRegionModel> = [];
  selectedRegion: AccountRegionModel;
  clrPosition: string = 'right';
  clrSize: string = 'right';
  openModal = false;
  languageId;
  logoUrl: string;

  private subscibe$: Subscription = new Subscription();

  supportModal: boolean;
  environment_values: any = {};
  API_CONFIG_values: any = {};
  build_Configurations_values: any = {};
  build_info_values: any = {};
  get tenantName(): string {
    return (this.common.tenantList || []).find(x => x.guid === this.common.tenantId)?.name || '';
  }

  filterItems: any = {
    id: { key: 'id', name: 'ID' },
    name: { key: 'name', name: 'Name' }
}
filters = [];

@ViewChild('dataGrid') dataGrid: ClrDatagrid;

  constructor(private readonly notifySvc: NotificationService, private readonly router: Router,
    private readonly i18Svc: InternationalizationService, public branding: BrandingService, public auth: AuthService,
    private readonly accountSrv: AccountService, private readonly common: CommonService,
    public userSrv: UserService) { }


    
  get username(): string {
    return this.auth.getUserName();
  }

  onGridStateChange(state: ClrDatagridStateInterface) {
    this.filters = state?.filters || [];
  }

  getRegions() {
    this.common.onLoadingAllRegionChange(true);
    this.accountSrv.getAllRegions()
      .subscribe(data => this.onRegionGet(data), err => this.onRegioGetError(err));
  }

  onRegionGet(data) {
    this.common.onLoadingAllRegionChange(false);
    if (data.result) {
      this.regions = [];
      data.result.forEach(x => this.regions.push(AccountRegionModel.parse(x)));
      this.common.onRegionAllChange(this.regions || []);
      if(this.regions?.length > 0) {
        if (this.regions?.length === 1) {
          this.setInitialRegion();
        } else if (this.selectedRegion?.id) {
          this.selectedRegion = this.regions.find(x => x.id === this.selectedRegion.id);
          if(!this.selectedRegion) {
            this.setInitialRegion();
          }
        } else {
          this.changeRegion();
        }
      } else {
        this.setEmptyRegion();
        this.changeRegionAction();
      }
    } else {
      this.setEmptyRegion();
      this.changeRegionAction();
      this.onRegioGetError(data.errorMessage);
    }
  }

  setInitialRegion() {
    this.selectedRegion = this.regions[0];
    this.changeRegionAction();
  }
  
  setEmptyRegion() {
    this.selectedRegion = AccountRegionModel.create();
    this.selectedRegion.id = undefined;
    this.selectedRegion.name = 'Select a region';
  }

  onRegioGetError(err) {
    this.common.onLoadingAllRegionChange(false);
    console.log(err);
  }

  changeRegion() {
    this.openModal = true;
  }
  changeRegionAction() {
    this.openModal = false;
    localStorage.setItem('current_region', this.selectedRegion?.id?.toString() || '');
    this.common.onRegionChange(this.selectedRegion?.id);
  }

  ngOnInit() {

    this.subscibe$ = this.auth.languageChanges$.subscribe((language: LanguageItem) => {
      

      if(this.languageId !== language?.id) {
        this.setLanguage(language);
    }
    });

    this.logoUrl = build_Configurations.logoUrl;
    let regionId = Number.parseInt((localStorage.getItem('current_region') ? localStorage.getItem('current_region') : this.auth.getRegion()) ?? undefined);
    this.selectedRegion = AccountRegionModel.create();
    this.selectedRegion.id = regionId;
    this.selectedRegion.name = 'Select a region';
    this.getRegions();
    this.branding.getBranding("");
    this.auth.setTier0Admin();

    this.environment_values = environment || {};
    this.API_CONFIG_values = API_CONFIG || {};
    this.build_Configurations_values = build_Configurations || {};
    this.build_info_values = build_info || {};


  }

  logout() {
    this.router.navigate(['/logout'], { queryParams: { returnUrl: this.router.url } });
  }

  editProfile() {
    window.location.href = `https://${API_CONFIG.AzureB2C.AuthorityDomain}/${API_CONFIG.AzureB2C.ServiceTenant}/oauth2/v2.0/authorize?p=${API_CONFIG.AzureB2C.EditProfile}&client_id=${API_CONFIG.AzureB2C.ClientId}&nonce=defaultNonce&redirect_uri=${window.location.origin}&scope=openid&response_type=id_token&prompt=login`
  }

  setToSoftRead(): void {
    this.notifySvc.setToSoftRead({}).subscribe(() => console.log('done'), err => this.errorHandler(err));
  }

  onNavigate(redirectUrl: string, index: number): void {
    this.router.navigate([redirectUrl]);
  }

  toSearch() {
    this.router.navigate(['search/search']);
  }

  mobileSidebarToggle() {
    this.toggleMobileSidebar.emit(true);
  }
  mobileRightSidebarToggle() {
    this.toggleMobileRightSidebar.emit(true);
  }
  toggleSidebarRight() {
    this.toggleSidebarRightCollapsed.emit(true);
  }
  setLocalLanguage(language: LanguageItem, reload?: boolean): void {
    if (language?.id !== this.languageId?.id) {
      localStorage.setItem('current_lang', language?.displayName?.toLowerCase());
      this.languageId = language?.id;
      this.auth.languageId = language?.id;
      this.i18Svc.initialize();
      if(reload) {
        this.auth.languageChanges$.next(language);
      }
    }
  }

  changeLanguage() {
    const selectedLanguage = (this.auth.languages || []).find(x => x.id?.toString() === this.languageId?.toString());
    if(selectedLanguage) {
      this.setLanguage(selectedLanguage);
    }
  }

  setLanguage(language: LanguageItem): void {
    this.setLocalLanguage(language, true);

    this.userSrv.changeLanguage(language?.displayName)
      .subscribe(x => this.onChangeLanguage(x));

  }

  onChangeLanguage(data) {
    if (data.statusCode === 200 && data.result) {
      this.setLocalLanguage(data.result?.value);
    } else {
      console.log('Error changing language' + data.message);
    }
  }

  onChangeTenant(tenantId: string) {
    this.common.setTenant(tenantId);
    this.setEmptyRegion();
    localStorage.setItem('current_region', this.selectedRegion?.id?.toString() || '');
    this.getRegions();
    this.common.selectedRegionsChange([]);
    this.reloadCurrentRoute();
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    const routeUrl = currentUrl === '/' || currentUrl === '/dashboard' ? '/error' : '/';
    this.router.navigateByUrl(routeUrl, { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  // General Functions
  errorHandler(error) {
    console.log(error);
  }

  openSupportModal() {
    this.supportModal = true;
  }
  
  closeSupportModal() {
    this.supportModal = false;
  }

  onDropdownKeyPress(e: KeyboardEvent) {
    if(this.common.isEnterClick(e)) {
      console.log(e);
    }
  }

  ngOnDestroy(): void {
    this.subscibe$?.unsubscribe();
  }

}
